import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authActions, alertActions } from '../../store/actions';
import Footer from '../../components/Footer/footer';
import { history } from '../../helpers/history';
import { Spring } from 'react-spring';
import { constants } from '../../Constants';
import defaultImage from '../../static/images/default_BG.png';
import '../../static/css/styles.css';
import { resetPassword } from '../../helpers/ConstantID';
import CustomModal from '../../components/CutomModal';

class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email_address: '',
			submitted: false,
			is_mobile: false,
			password1: '',
			password2: '',
			showModal: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		this.props.clearAlertActions();
		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
	}

	handleChange(e) {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}

	handleSubmit = (ev) => {
		ev.preventDefault();

		const { dispatch } = this.props;

		this.setState({ submitted: true });
		const { password1, password2 } = this.state;

		const code = this.props.match.params.code;
		if (password1 === '' || password2 === '') {
			const message = constants.FILL_ALL_FIELDS_MSG;
			this.props.alertError(message);
		} else if (password1.length < 6 || password2.length < 6) {
			const message = constants.PASSWORD_LIMIT_MSG;
			this.props.alertError(message);
		} else if (password1 !== password2) {
			const message = constants.PASSWORD_DONOT_MATCH_MSG;
			this.props.alertError(message);
		} else {
			this.props.updatePassword(password1, password2, code);
		}
	};
	login = () => {
		history.replace('/');
	};
	register = () => {
		history.push('/registration');
	};

	closeModal = () => {
		this.setState({
			showModal: !this.state.showModal,
		});
		setTimeout(() => {
			this.setState({ showModal: false });
		}, 3000);
	};

	render() {
		const { alert, whitelabel } = this.props;
		const showError = alert.message && alert.message.length > 0;
		return (
			<div className="sh-layout">
				<div className="sh-reset-pass-comp">
					<div className="sh-gnrl-inner">
						<div className="sh-gnrl-logo">
							<img
								src={whitelabel ? whitelabel[0].logo_url : defaultImage}
								alt="logo"
								id={resetPassword.sh_rp_logo}
							/>
						</div>
						<div className="sh-rpc-heading">
							<h2 className="sh-rpc-h2" id={resetPassword.sh_rp_text1}>
								{constants.NEW_PWD_TXT}
							</h2>
							<p className="sh-rpc-gnrl-text sh-mb-15" id={resetPassword.sh_rp_text2}>
								{constants.IDENTITY_VERIFIED_TXT}
								<br /> {constants.SET_NEW_PWD_TXT}
							</p>
						</div>
						<div className="sh-rpc-form">
							<div className="sh-gnrl-row sh-mb-15">
								<div className="sh-input-group">
									<input
										autoComplete="off"
										id={resetPassword.sh_rp_pass}
										required
										name="password1"
										type="password"
										className={`sh-input-text ${showError ? 'sh-input-error' : ''}`}
										onChange={this.handleChange}
									/>
									<label htmlFor={resetPassword.sh_rp_pass} className="sh-input-label">
										{constants.NEW_PWD_TXT}
									</label>
								</div>
							</div>

							<div className="sh-gnrl-row sh-mb-15">
								<div className="sh-input-group">
									<input
										autoComplete="off"
										id={resetPassword.sh_rp_c_pass}
										name="password2"
										required
										type="password"
										className={`sh-input-text ${showError ? 'sh-input-error' : ''}`}
										onChange={this.handleChange}
									/>
									<label htmlFor={resetPassword.sh_c_rp_pass} className="sh-input-label">
										{constants.CONFIRM_PASSWORD}
									</label>
								</div>
							</div>
							<div className="sh-grnl-row sh-mb-5">
								<span className="sh-gnrl-error-msg">{alert.message}</span>
							</div>

							<div className="sh-gnrl-row sh-mb-10">
								<button
									id={resetPassword.sh_rp_sign_in_btn}
									onClick={this.handleSubmit}
									className="sh-gnrl-btn sh-login-btn"
								>
									{constants.SAVE_TXT}
								</button>
							</div>

							<div className="sh-gnrl-row">
								<label htmlFor={resetPassword.sh_rp_cs_btn} className="sh-rpc-cnslr">
									{constants.NEED_HELP_TXT} <span>{constants.CUSTOMER_SUPPORT_TXT}</span>
								</label>
								<button
									className="sh-rpc-cnslr-btn"
									onClick={() => {
										console.log('this is button click');
									}}
									id={resetPassword.sh_rp_cs_btn}
								></button>
							</div>
						</div>
					</div>
				</div>
				<Footer />
				{this.state.showModal && (
					<Spring
						from={{ transform: 'translate(+100%, 0)' }}
						to={{ transform: 'translate(0%, 0)' }}
						leave={{ transform: 'translate(-100%, 0)' }}
					>
						{(props) => <CustomModal closeModal={this.closeModal} style={props} />}
					</Spring>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const { authstate } = state.auth;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		authstate,
		whitelabel,
	};
}
const mapDispatchToProps = (dispatch) => {
	return {
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
		updatePassword: (password1, password2, code) => {
			dispatch(authActions.newPassword(password1, password2, code));
		},
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));



// WEBPACK FOOTER //
// ./src/screens/ForgotPassword/index.js